import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mh-auth-form-header',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './auth-form-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthFormHeaderComponent {
  readonly titleKey = input.required<string>();
  readonly explainKey = input.required<string>();
}
